var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUiLight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6B8AFE3A-563B-4DB0-B5A7-0ABE8F424447") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.607892 0 0 0 0 0.607803 0 0 0 0 0.607923 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wireframes-2.0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ui",
    transform: "translate(-24.000000, -637.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.000000, 637.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0 C5.372583,0 9.09494702e-13,5.372583 9.09494702e-13,12 C9.09494702e-13,18.627417 5.372583,24 12,24 C18.627417,24 24,18.627417 24,12 C23.9921853,5.37582267 18.6241773,0.007814728 12,0 Z M12,21.8181818 C6.57756791,21.8181818 2.18181818,17.4224321 2.18181818,12 C2.18181818,6.57756791 6.57756791,2.18181818 12,2.18181818 C17.4224321,2.18181818 21.8181818,6.57756791 21.8181818,12 C21.8121697,17.4199398 17.4199398,21.8121697 12,21.8181818 L12,21.8181818 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.664293,7.33563323 C16.2349187,6.90648297 15.5389029,6.90648297 15.1095286,7.33563323 L12,10.4455775 L8.89047136,7.33563323 C8.61440231,7.04986069 8.2055857,6.93525115 7.8211505,7.03585487 C7.43671531,7.13645859 7.1364886,7.43661929 7.03586276,7.82096996 C6.93523691,8.20532064 7.04987166,8.61404737 7.33570704,8.89005572 L10.4452357,12 L7.33570704,15.1099443 C7.04987166,15.3859526 6.93523691,15.7946794 7.03586276,16.17903 C7.1364886,16.5633807 7.43671531,16.8635414 7.8211505,16.9641451 C8.2055857,17.0647488 8.61440231,16.9501393 8.89047136,16.6643668 L12,13.5544225 L15.1095286,16.6643668 C15.3855977,16.9501393 15.7944143,17.0647488 16.1788495,16.9641451 C16.5632847,16.8635414 16.8635114,16.5633807 16.9641372,16.17903 C17.0647631,15.7946794 16.9501283,15.3859526 16.664293,15.1099443 L13.5547643,12 L16.664293,8.89005572 C17.0935376,8.46077583 17.0935376,7.76491311 16.664293,7.33563323 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUiLight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ui_light.6811f009ffd4aef1eb51c8fee32138cf.svg";